import {observer} from 'mobx-react-lite'
import React, {useContext} from 'react'
import {Highlight} from '@components/common/highlight/highlight'
import {cn} from '@containers/html-utils'
import {PropsContext, useUsersTableStore} from '../users-table-store'

export const HighlightQuery = observer(
  (props: {text: string; className?: string}) => {
    const [state] = useUsersTableStore()
    const rootProps = useContext(PropsContext)
    return (
      <div
        className={cn(
          'whitespace-nowrap text-ellipsis overflow-hidden text-primary',
          rootProps.large ? 'text-14' : 'text-12',
          props.className,
          'px-8 flex items-center'
        )}
      >
        <Highlight text={props.text ?? ''} highlight={state.searchQuery} />
      </div>
    )
  }
)
